import { SERVER_URL } from "../constants/app.constants";
export const LOGIN_DIALOGS = {
  invalidFRGTPWDetails: "Please enter correct User name and Email ID.",
  invalidFRGTDetails: "Details are invalid.",
  problemSendingEmail: "There is problem sending email, please contact admin.",
  emailSuccess:
    "Password sent successfully to your registered email address. Kindly review your email inbox for instructions on resetting your password.",
  fillDetailsFRGT: "Please fill the details properly.",
  accountDeactivate:
    "Your account has been deactivated,please contact administrator.",
  invalidLoginDetails: "Please enter valid login details.",
  emptyLoginDetails: "Please enter login details.",
  loginFailed: "Login failed!",
  invalidEmailAddress: "Email Address is not valid.",
  incorrectPW: "Current Password is incorrect.",
  newPWlenght: "Please enter password of min 5 character.",
  passwordMatch: "New Password does not match with Confirm Password.",
  changePasswordDetails: "Please enter required fields properly.",
  technicalError: "There is some technical issue, please try after sometime.",
  invalidResetPassword: "Please enter valid passwords.",
  invalidPasswordMismatch: "Entered passwords do not match.",
  successResetPassword: `<span style="color:green">Password updated successfully!!</span><br/><span style="color:black">Please <a href="${SERVER_URL}login">login</a></span>`,
  invalidToken: `Invalid Token or Token is expired. <br/>Generate new token <a href="${SERVER_URL}forgotpassword">Generate Token</a>`,
  changePasswordSuccess: "Password updated successfully."
};
export const ERROR_MESSAGE = "No data available."
  //"The data is temporarily unavailable. Please try again later.";

export const NODATA_ERROR_MESSAGE = "No records found";
